/* eslint-disable */
import AppHeader from "@saleor/components/AppHeader";
import AvailabilityCard from "@saleor/components/AvailabilityCard";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Grid from "@saleor/components/Grid";
import Metadata from "@saleor/components/Metadata/Metadata";
import PageHeader from "@saleor/components/PageHeader";
import RecommendProductSection from "@saleor/components/RecommendProductSection";
// import RecommendProductSection, {
//   RecommendProductTab
// } from "@saleor/components/RecommendProductSection";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import SeoForm from "@saleor/components/SeoForm";
// import cornermarks from "@saleor/cornermarks";
import { ProductErrorWithAttributesFragment } from "@saleor/fragments/types/ProductErrorWithAttributesFragment";
import { TaxTypeFragment } from "@saleor/fragments/types/TaxTypeFragment";
import { WarehouseFragment } from "@saleor/fragments/types/WarehouseFragment";
import useDateLocalize from "@saleor/hooks/useDateLocalize";
import { SubmitPromise } from "@saleor/hooks/useForm";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchCategories_search_edges_node } from "@saleor/searches/types/SearchCategories";
import { SearchCollections_search_edges_node } from "@saleor/searches/types/SearchCollections";
import { FetchMoreProps, ListActions, ReorderAction } from "@saleor/types";
import {
  RecommendationTargetTypeEnum,
  LensTypeTemplateEnum
} from "@saleor/types/globalTypes";
import { RawDraftContentState } from "draft-js";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import { TabListActions } from "../../../types";
import {
  ProductDetails_product,
  ProductDetails_product_imagesDas,
  ProductDetails_product_productIns,
  ProductDetails_product_variants
} from "../../types/ProductDetails";
import { getChoices, ProductUpdatePageFormData } from "../../utils/data";
import ProductAttributes, { ProductAttributeInput } from "../ProductAttributes";
import ProductDetailsForm from "../ProductDetailsForm";
import ProductImages from "../ProductImages";
import ProductOrganization from "../ProductOrganization";
import ProductPricing from "../ProductPricing";
import ProductShipping from "../ProductShipping/ProductShipping";
import ProductStocks, { ProductStockInput } from "../ProductStocks";
import ProductTaxes from "../ProductTaxes";
// import ProductVariantCornermarks from "../ProductVariantCornermarks";
import ProductVariantIns from "../ProductVariantIns";
import ProductVariants from "../ProductVariants";
import ProductUpdateForm from "./form";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
// import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import { createPaginationState } from "@saleor/hooks/usePaginator";
import { useProducttagsListQuery } from "@saleor/producttags/queries";
// import { ProducttagsListUrlQueryParams } from "@saleor/producttags/urls";
import { PAGINATE_BY } from "@saleor/config";
import { Card, CardContent } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import SingleSelectField from "@saleor/components/SingleSelectField";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      width: "380px",
      borderRadius: "4px"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

let selectList = [];

export interface ProductUpdatePageProps
  extends ListActions,
    TabListActions<
      "recommendToolbar" | "alsolikeToolbar" | "buytogetherToolbar"
    > {
  // changeTab: (index: RecommendProductTab) => void;
  // currentTab: RecommendProductTab;
  isBuytogether?: boolean;
  defaultWeightUnit: string;
  errors: ProductErrorWithAttributesFragment[];
  placeholderImage: string;
  collections: SearchCollections_search_edges_node[];
  categories: SearchCategories_search_edges_node[];
  disabled: boolean;
  fetchMoreCategories: FetchMoreProps;
  fetchMoreCollections: FetchMoreProps;
  variants: ProductDetails_product_variants[];
  images: ProductDetails_product_imagesDas[];
  product: ProductDetails_product;
  header: string;
  saveButtonBarState: ConfirmButtonTransitionState;
  warehouses: WarehouseFragment[];
  taxTypes: TaxTypeFragment[];
  productIns?: ProductDetails_product_productIns[];
  onInsReorder?: ReorderAction;
  fetchCategories: (query: string) => void;
  fetchCollections: (query: string) => void;
  onVariantsAdd: () => void;
  onImagesClean: () => void;
  onPriceSet: () => void;
  onVariantShow: (id: string) => () => void;
  onVariantReorder: ReorderAction;
  onRecommendAssign: () => void;
  onAlsolikeAssign: () => void;
  onBuytogetherAssign: () => void;
  onRecommendUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onAlsolikeUnassign: (id: string, event: React.MouseEvent<any>) => void;
  onBuytogetherUnAssign: (id: string, event: React.MouseEvent<any>) => void;
  onImageDelete: (id: string) => () => void;
  onSubmit: (data: ProductUpdatePageSubmitData) => SubmitPromise;
  onBack?();
  onDelete();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  onDeleteIns?: (id: string) => void;
  onImageEdit?(id: string);
  onImageReorder?(event: { oldIndex: number; newIndex: number });
  onImageUpload(file: File);
  onImageFetch(variantId: string);
  onDetailpageImageFetch?(productId: string);
  onSeoClick?();
  onVariantAdd?();
  onSetDefaultVariant(variant: ProductDetails_product_variants);
  onWarehouseConfigure();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  onAddIns?: () => void;
  onCopyIns?: () => void;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  onRowClick?: (id: string) => void;
  reverseVisible?: (data: ProductDetails_product_productIns[]) => void;
  fetchCornermarks?: (data: string) => void;
  fetchMoreCornermarks?: FetchMoreProps;
  params?: any;
  onVisibleEdit?: (url: string) => void;
  onInsSelectReorder?: (insId: string, sortOrder: number) => void;
}

export interface ProductUpdatePageSubmitData extends ProductUpdatePageFormData {
  attributes: ProductAttributeInput[];
  collections: string[];
  addStocks: ProductStockInput[];
  updateStocks: ProductStockInput[];
  removeStocks: string[];
}

// const queryVariables = React.useMemo(
//   () => ({
//     // ...paginationState
//     // filter: getFilterVariables(params)
//     //   sort: getSortQueryVariables(params)
//   }),
//   // [params]
// );

export const ProductUpdatePage: React.FC<ProductUpdatePageProps> = ({
  // changeTab,
  // currentTab,
  isBuytogether,
  defaultWeightUnit,
  disabled,
  categories: categoryChoiceList,
  collections: collectionChoiceList,
  errors,
  fetchCategories,
  fetchCollections,
  fetchMoreCategories,
  fetchMoreCollections,
  images,
  header,
  placeholderImage,
  product,
  saveButtonBarState,
  variants,
  warehouses,
  taxTypes,
  productIns,
  onInsReorder,
  onBack,
  onDelete,
  onDeleteIns,
  onImageDelete,
  onImageEdit,
  onImageReorder,
  onImageUpload,
  onImageFetch,
  onDetailpageImageFetch,
  onSeoClick,
  onSubmit,
  onVariantAdd,
  onVariantsAdd,
  onImagesClean,
  onPriceSet,
  onSetDefaultVariant,
  onVariantShow,
  onVariantReorder,
  onWarehouseConfigure,
  onRecommendAssign,
  onAlsolikeAssign,
  onBuytogetherAssign,
  onRecommendUnassign,
  onAlsolikeUnassign,
  onBuytogetherUnAssign,
  isChecked,
  selected,
  toggle,
  toggleAll,
  onAddIns,
  onCopyIns,
  toolbar,
  recommendToolbar,
  alsolikeToolbar,
  buytogetherToolbar,
  onRowClick,
  params,
  reverseVisible,
  onVisibleEdit,
  onInsSelectReorder
  // fetchCornermarks,
  // fetchMoreCornermarks,
}) => {
  const intl = useIntl();

  const lensTypeTemplateChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Classic",
        description: "lensTypeTemplate choice"
      }),
      value: LensTypeTemplateEnum.CLASSIC
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Plus",
        description: "lensTypeTemplate choice"
      }),
      value: LensTypeTemplateEnum.PLUS
    }
  ];

  const localizeDate = useDateLocalize();

  const paginationState = createPaginationState(PAGINATE_BY, params);

  const queryVariables = React.useMemo(
    () => ({
      ...paginationState
    }),
    [params]
  );

  const { data } = useProducttagsListQuery({
    variables: queryVariables
  });

  selectList = [];
  const producttagsList = [];
  if (data) {
    data.producttags.edges.forEach(item => {
      const obj = {
        text: "",
        id: ""
      };
      obj.text = item.node.name;
      obj.id = item.node.id;
      selectList.push(item.node.name);
      producttagsList.push(obj);
    });
  }

  const [selectedCategory, setSelectedCategory] = useStateFromProps(
    product?.category?.name || ""
  );

  const [selectedCollections, setSelectedCollections] = useStateFromProps(
    getChoices(maybe(() => product.collections, []))
  );

  const [selectedTaxType, setSelectedTaxType] = useStateFromProps(
    product?.taxType.description
  );

  const initialDescription = maybe<RawDraftContentState>(() =>
    JSON.parse(product.description)
  );

  const categories = getChoices(categoryChoiceList);
  const collections = getChoices(collectionChoiceList);
  // const currency = product?.variants[0]?.price.currency;
  const currency = product?.variants
    ? product?.variants[0]?.price.currency
    : "USD";
  const hasVariants = product?.productType?.hasVariants;
  const taxTypeChoices =
    taxTypes?.map(taxType => ({
      label: taxType.description,
      value: taxType.taxCode
    })) || [];

  const classes = useStyles();
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [idList1, setidList] = React.useState<string[]>([]);
  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    // console.log(event.target.value);
    setPersonName(event.target.value as string[]);

    let idList = [];
    producttagsList.forEach(item => {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < event.target.value.length; i++) {
        if (event.target.value[i] === item.text) {
          idList.push(item.id);
        }
      }
    });
    setidList(idList);
  };

  useEffect(() => {
    if (!product) {
      return undefined;
    }
    if (product.producttagsSpu.length != 0) {
      let personName1 = [];
      let idList1 = [];
      product.producttagsSpu.forEach(item => {
        // if (myIndex === 1) {
        personName1.push(item.name);
        setPersonName(personName1);
        // idList.push(item.id);
        idList1.push(item.id);
        setidList(idList1);
        // }
      });
    }
  }, [product]);

  const getCookie = name => {
    let arr;
    const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    // eslint-disable-next-line
    if ((arr = document.cookie.match(reg))) {
      // return unescape(arr[2]);
      return arr[2];
    } else {
      return null;
    }
  };

  // 保存选中的
  const savaSelect = () => {
    // personName.splice(0, personName.length);
    fetch(localStorage.getItem("shop_api_uri"), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "JWT " + getCookie("dashboardToken")
      },
      method: "POST",
      body: JSON.stringify({
        operationName: null,
        query:
          'mutation {\n  producttagsChoiceCreate(productId: "' +
          product.id +
          '", typeNumber: "2", producttags: ' +
          JSON.stringify(idList1) +
          ") {\n    producttagsErrors {\n      field\n      message\n      code\n    }\n    product {\n      id\n      name\n    }\n  }\n}\n",
        variables: {}
      }),
      mode: "cors" // no-cors, cors, *same-origin
    })
      .then(function(response) {
        if (response.status === 200) {
          // personName.splice(0, personName.length);
          document.querySelector<HTMLElement>(
            ".AppLayout-appAction-32"
          ).style.position = "sticky";
        }
      })
      .catch(err => {
        console.error("错误", err);
      });
  };

  return (
    <ProductUpdateForm
      onSubmit={onSubmit}
      product={product}
      categories={categories}
      collections={collections}
      selectedCollections={selectedCollections}
      setSelectedCategory={setSelectedCategory}
      setSelectedCollections={setSelectedCollections}
      setSelectedTaxType={setSelectedTaxType}
      taxTypes={taxTypeChoices}
      warehouses={warehouses}
    >
      {({ change, data, handlers, submit }) => (
        <>
          <Container>
            <AppHeader onBack={onBack}>
              {intl.formatMessage(sectionNames.products)}
            </AppHeader>
            <PageHeader title={header} />
            <Grid>
              <div>
                {hasVariants ? (
                  <ProductVariants
                    disabled={disabled}
                    variants={variants}
                    product={product}
                    fallbackPrice={
                      product?.variants?.length
                        ? product.variants[0].price
                        : undefined
                    }
                    onRowClick={onVariantShow}
                    onVariantAdd={onVariantAdd}
                    onVariantsAdd={onVariantsAdd}
                    onImagesClean={onImagesClean}
                    onPriceSet={onPriceSet}
                    onVariantReorder={onVariantReorder}
                    onSetDefaultVariant={onSetDefaultVariant}
                    toolbar={toolbar}
                    isChecked={isChecked}
                    selected={selected}
                    toggle={toggle}
                    toggleAll={toggleAll}
                  />
                ) : (
                  <>
                    <ProductShipping
                      data={data}
                      disabled={disabled}
                      errors={errors}
                      weightUnit={product?.weight?.unit || defaultWeightUnit}
                      onChange={change}
                    />
                    <CardSpacer />
                    <ProductStocks
                      data={data}
                      disabled={disabled}
                      hasVariants={false}
                      errors={errors}
                      stocks={data.stocks}
                      warehouses={warehouses}
                      onChange={handlers.changeStock}
                      onFormDataChange={change}
                      onWarehouseStockAdd={handlers.addStock}
                      onWarehouseStockDelete={handlers.deleteStock}
                      onWarehouseConfigure={onWarehouseConfigure}
                    />
                  </>
                )}
                <CardSpacer />
                <ProductDetailsForm
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  initialDescription={initialDescription}
                  onChange={change}
                />
                <CardSpacer />
                {data.attributes.length > 0 && (
                  <ProductAttributes
                    attributes={data.attributes}
                    errors={errors}
                    disabled={disabled}
                    onChange={handlers.selectAttribute}
                    onMultiChange={handlers.selectAttributeMultiple}
                  />
                )}
                <CardSpacer />

                <ProductVariantIns
                  productIns={productIns}
                  onInsReorder={onInsReorder}
                  onDeleteIns={onDeleteIns}
                  onAddIns={onAddIns}
                  onCopyIns={onCopyIns}
                  onRowClick={onRowClick}
                  reverseVisible={reverseVisible}
                  onInsSelectReorder={onInsSelectReorder}
                ></ProductVariantIns>
                <CardSpacer />

                {!!product?.productType && !hasVariants && (
                  <>
                    <ProductPricing
                      currency={currency}
                      data={data}
                      disabled={disabled}
                      errors={errors}
                      onChange={change}
                    />
                    <CardSpacer />
                  </>
                )}
                <SeoForm
                  errors={errors}
                  title={data.seoTitle}
                  keyword={data.seoKeyword}
                  titlePlaceholder={data.name}
                  keywordPlaceholder={data.name}
                  description={data.seoDescription}
                  descriptionPlaceholder={data.description}
                  slug={data.slug}
                  slugPlaceholder={data.name}
                  loading={disabled}
                  onClick={onSeoClick}
                  onChange={change}
                  helperText={intl.formatMessage({
                    defaultMessage:
                      "Add search engine title and description to make this product easier to find"
                  })}
                />
                <CardSpacer />
                <RecommendProductSection
                  isBuytogether={isBuytogether}
                  disabled={disabled}
                  // changeTab={changeTab}
                  // currentTab={currentTab}
                  target={product}
                  targetType={RecommendationTargetTypeEnum.PRODUCT}
                  onRecommendAssign={onRecommendAssign}
                  onAlsolikeAssign={onAlsolikeAssign}
                  onBuytogetherAssign={onBuytogetherAssign}
                  onRecommendUnassign={onRecommendUnassign}
                  onAlsolikeUnassign={onAlsolikeUnassign}
                  onBuytogetherUnAssign={onBuytogetherUnAssign}
                  isChecked={isChecked}
                  selected={selected}
                  toggle={toggle}
                  toggleAll={toggleAll}
                  recommendToolbar={recommendToolbar}
                  alsolikeToolbar={alsolikeToolbar}
                  buytogetherToolbar={buytogetherToolbar}
                />
                <CardSpacer />

                <ProductImages
                  images={images}
                  product={product}
                  placeholderImage={placeholderImage}
                  onImageDelete={onImageDelete}
                  onImageReorder={onImageReorder}
                  onImageEdit={onImageEdit}
                  onImageUpload={onImageUpload}
                  onImageFetch={onImageFetch}
                  onDetailpageImageFetch={onDetailpageImageFetch}
                  onVisibleEdit={onVisibleEdit}
                />
                <CardSpacer />
                <Metadata data={data} onChange={handlers.changeMetadata} />
              </div>
              <div>
                <ProductOrganization
                  canChangeType={false}
                  categories={categories}
                  categoryInputDisplayValue={selectedCategory}
                  collections={collections}
                  collectionsInputDisplayValue={selectedCollections}
                  data={data}
                  disabled={disabled}
                  errors={errors}
                  fetchCategories={fetchCategories}
                  fetchCollections={fetchCollections}
                  fetchMoreCategories={fetchMoreCategories}
                  fetchMoreCollections={fetchMoreCollections}
                  productType={product?.productType}
                  onCategoryChange={handlers.selectCategory}
                  onCollectionChange={handlers.selectCollection}
                />
                <CardSpacer />
                <AvailabilityCard
                  data={data}
                  errors={errors}
                  disabled={disabled}
                  messages={{
                    hiddenLabel: intl.formatMessage({
                      defaultMessage: "Not published",
                      description: "product label"
                    }),
                    hiddenSecondLabel: intl.formatMessage(
                      {
                        defaultMessage: "will become published on {date}",
                        description: "product publication date label"
                      },
                      {
                        date: localizeDate(data.publicationDate, "L")
                      }
                    ),
                    visibleLabel: intl.formatMessage({
                      defaultMessage: "Published",
                      description: "product label"
                    })
                  }}
                  onChange={change}
                />
                <CardSpacer />
                <ProductTaxes
                  data={data}
                  disabled={disabled}
                  selectedTaxTypeDisplayName={selectedTaxType}
                  taxTypes={taxTypes}
                  onChange={change}
                  onTaxTypeChange={handlers.selectTaxRate}
                />
                <CardSpacer />

                <Card>
                  <CardTitle
                    title={intl.formatMessage({
                      defaultMessage: "Template",
                      description: "section header"
                    })}
                  />
                  <CardContent>
                    <SingleSelectField
                      disabled={disabled}
                      choices={lensTypeTemplateChoices}
                      label={intl.formatMessage({
                        defaultMessage: "Lens Type",
                        description: "Lens Type choice."
                      })}
                      name="lensTypeTemplate"
                      onChange={change}
                      value={data.lensTypeTemplate}
                    />
                  </CardContent>
                </Card>
                <CardSpacer />

                <Card>
                  <CardTitle
                    title={intl.formatMessage({
                      defaultMessage: "ProductTags",
                      description: "section header"
                    })}
                  />
                  <CardContent>
                    <FormControl className={classes.root}>
                      <Select
                        labelId="demo-mutiple-checkbox-label"
                        id="demo-mutiple-checkbox"
                        style={{ paddingLeft: "12px" }}
                        multiple
                        value={personName}
                        onChange={handleChange}
                        input={<Input />}
                        renderValue={selected =>
                          (selected as string[]).join(", ")
                        }
                        MenuProps={MenuProps}
                      >
                        {selectList.map(name => (
                          <MenuItem key={name} value={name}>
                            {/* <Checkbox checked={true} /> */}
                            <Checkbox checked={personName.indexOf(name) > -1} />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </CardContent>
                </Card>
              </div>
            </Grid>
            <SaveButtonBar
              onCancel={onBack}
              onDelete={onDelete}
              // onSave={ submit}
              onSave={() => {
                submit();
                savaSelect();
              }}
              state={saveButtonBarState}
              disabled={false}
            />
          </Container>
        </>
      )}
    </ProductUpdateForm>
  );
};
ProductUpdatePage.displayName = "ProductUpdatePage";
export default ProductUpdatePage;
